import { render } from "./DeathOfPartner.vue?vue&type=template&id=3361c874"
import script from "./DeathOfPartner.vue?vue&type=script&lang=js"
export * from "./DeathOfPartner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__